import React, { useEffect, useState } from 'react'
import InputField from '../../../library/components/InputField'
import { Validators } from '../../../library/utilities/Validator'
// import CaptchaPage from '../../captcha/captchaPage1'
import captcha from '../../../images/captcha.svg'
import eclipse from '../../../images/eclipse.svg'
import vector from '../../../images/vector.svg'
import '../login.css'
import Button from '../../../library/components/Button'
import { Link, useLocation } from 'react-router-dom'
import PasswordField from '../../../library/components/Password'
import {
  useGetCaptchaServiceQuery,
  useGetCaptchaVerifyQuery,
} from '../../../services/captchaService'
import { UnderLine } from '../../../ui'
import Login from './login'
import SelectField from '../../../library/components/Select'
import CaptchaPage from '../../captcha/captchaPage'


const Designation = [
  { value: "", label: "----Select----" },
  { value: "*", label: "ECI" },
  { value: "*1", label: "Chief Electoral Officer" },
  { value: "*2", label: "District Election Officer" },
  // { value: "*3", label: "Electoral Registration Officer" },
  { value: "ro", label: "Returning Officer" },
  { value: "cs", label: "Counting Supervisor" },
]

function LoginFormDetails({
  loginObj,
  setLoginObj,
  exceedError,
  resetPassword,
  Error,
  setError,
  captchaVerify,
  formname,
  captchaId,
  setCaptchaId,
  errorData,
  setErrorData,
  captchaData,
  setCaptchaArg,
  captchaArg,
}) {
  // const [captchaImage, setCaptchaImage] = useState()
  const [buttoneDis, setbuttoneDis] = useState(true);
  // const [captchaArg, setCaptchaArg] = useState(true)
  // const [errorMsg, setErrorMsg] = useState('')
  // const [CaptchaId, setCaptchaId] = useState('')
  // const [verifyCaptcha, callVerifyCaptcha] = useState(true)

  // const [captchaButton, setCaptchaButton] = useState(true)

  // const { data: getCaptcha } = useGetCaptchaServiceQuery(captchaArg, {
  //   refetchOnMountOrArgChange: true,
  // })
  // const {
  //   data: captchaVerifyData,
  //   isLoading: cpVerifyLoading,
  //   isError: cpVerifyIsError,
  //   error: captchaError,
  //   responseInfo,
  // } = useGetCaptchaVerifyQuery(
  //   { CaptchaId, id: getCaptcha?.id },
  //   { skip: verifyCaptcha },
  // )

  // useEffect(() => {
  //   if (getCaptcha) setCaptchaImage(getCaptcha)
  // }, [getCaptcha])

  // useEffect(() => {
  //   if (captchaVerifyData || captchaError) {
  //     if (captchaVerifyData?.statusCode !== 200) {
  //       setErrorMsg('Please Enter Valid Captcha')
  //       setCaptchaArg(!captchaArg)
  //       callVerifyCaptcha(true)
  //     } else {
  //       captchaVerify(true)
  //       setCaptchaId('')
  //       callVerifyCaptcha(true)
  //       // setCaptchaButton(false)
  //     }
  //   }
  // }, [captchaVerifyData, cpVerifyIsError, cpVerifyLoading])

  const getError = (key, value) => {
    let error = { ...Error }
    if (value && value.message) {
      setError({ ...Error, [key]: value.message })
    } else {
      delete error[key]
      setError(error)
    }
  }
  // const enableSidebar = () => {
  //   props.clickNext();
  // };
  const location = useLocation()
  // const state = location.state;

  // const exceedError = state ? state.exceed : null;

  // const resetPassword = state ? state.reset : null;

  const handleChange = (key, event) => {
    setLoginObj({ ...loginObj, [key]: event })
  }

  // const requestOtp = () => {
  //   callVerifyCaptcha(false)
  // }

  return (
    <>
      {/* <div className='row p-2'>
        <SelectField
          label="User Type"
          name="userType"
          inputClass="col-md-12"
          labelClass="col-md-12"
          value={loginObj.userType}
          handleChange={(val) => handleChange("userType", val)}
          options={Designation}
          required={true}
          validators={[
            {
              check: Validators.required,
              message: "This field is required",
            }
          ]}
          getError={(val) => getError("userType", val)}
          Error={Error}
        />
      </div> */}
      <div className="row pb-1">
        <InputField
          label="Username"
          onPaste={true}
          onDrop={true}
          onCopy={true}
          onCut={true}
          autoComplete={"off"}
          maxLength="100"
          name="userId"
          required={true}
         iconclass="fas fa-envelope"
          placeholder=" Enter User id"
          inputClass="col-md-12 forminputLogin"
          labelClass="col-md-12 d-none"
          value={loginObj.userId}
          onChange={(val) => handleChange('userId', val)}
          validators={[
            {
              check: Validators.nospecial,
              message: "Please enter valid userId.",
            },
            {
              check: Validators.NotAnEro,
              message: "User Not allowed.",
            },
            {
              check: Validators.required,
              message: 'This field is required',
            },
          ]}
          getError={(val) => getError('userId', val)}
          Error={Error}
        />
      </div>
    
      <div className="row ">
        <div className="col-md-12 captchatext">
        
          <CaptchaPage
            error={errorData}
            buttonDisabled={Object.keys(Error).length != 0}
            captchaData={captchaData}
            setCaptchaArg={setCaptchaArg}
            setCaptchaId={setCaptchaId}
            setErrorMsg={setErrorData}
            captchaArg={captchaArg}
            captchaId={captchaId}
            onPaste={true}
            onDrop={true}
            onCopy={true}
            onCut={true}
            autoComplete={"off"}
            // captchaText="Captcha"
                 captchaLabel={"d-none"}
            style={"forminputCaptcha"}
          />
        </div>
      </div>
      <div className="row  pl-3"> 
      <Button
        btnClass="btn-block submit mb-4 btnpurple"
        value={`Request OTP`}
        onClick={() => {}}
        disabled={
          Object.keys(Error).length != 0 ||
          captchaId == "" ||
          loginObj.userId == ""
        }
        type="submit"
      />
      </div>
      {/* <Button
        btnClass="btn-block submit"
        value={`${exceedError || resetPassword ? "Login" : "Request OTP"}`}
        onClick={() => { }}
        disabled={buttoneDis}
        type="submit"
      />
      {exceedError && (
        <div className="displayMessage">
          You cannot login. You have exceeded the maximum limit. Please try
          again tomorrow.
        </div>
      )}
      {resetPassword && (
        <div className="displayMessage">
          Time to reset your password, by clicking the Forgot Password button
          below.
        </div>
      )} */}
    </>
  )
}

export default LoginFormDetails
